import React, { useState } from "react";
import { Button, Form, Message } from "semantic-ui-react";
import { useFormik } from "formik";
import { User } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { inititalValues, validationSchema } from "./ResetPasswordForm.form";
import "./ResetPasswordForm.scss";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../../contexts";

const userController = new User();

export function ResetPasswordForm({ userByToken }) {
  const [error, setError] = useState("");
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const navigate=useNavigate();
  const formik = useFormik({
    initialValues: {
      email: userByToken.email || "",
      password: "",
      repeatPassword: "",
      resetPasswordToken: userByToken.resetPasswordToken || "",
    },
    validationSchema: validationSchema(t),
    validateOnChange: false,
    onSubmit: async (formValue) => {
  try {
    // Aquí usamos el token que viene de userByToken
    const response = await userController.updatePasswordByTokenApi(
      {
        email: formValue.email,
        password: formValue.password,
        repeatPassword: formValue.repeatPassword,
      },
      userByToken.resetPasswordToken // <-- token separado
    );

    if (response && response.code === 200) {
      navigate("/admin");
    } else {
      setError(response.message || t("error_updating_password"));
    }
  } catch (error) {
    console.error(error);
    setError(error.msg || t("error_updating_password"));
  }
}

  });

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Form.Field>
        <label>{t("email")}</label>
        <input
          name="email"
          placeholder={t("email")}
          value={formik.values.email}
          onChange={formik.handleChange}
        />
        {formik.errors.email && <span style={{ color: "red" }}>{formik.errors.email}</span>}
      </Form.Field>

      <Form.Field>
        <label>{t("password")}</label>
        <input
          type="password"
          name="password"
          placeholder={t("password")}
          value={formik.values.password}
          onChange={formik.handleChange}
        />
        {formik.errors.password && <span style={{ color: "red" }}>{formik.errors.password}</span>}
      </Form.Field>

      <Form.Field>
        <label>{t("repeat_password")}</label>
        <input
          type="password"
          name="repeatPassword"
          placeholder={t("repeat_password")}
          value={formik.values.repeatPassword}
          onChange={formik.handleChange}
        />
        {formik.errors.repeatPassword && <span style={{ color: "red" }}>{formik.errors.repeatPassword}</span>}
      </Form.Field>

      <input type="hidden" name="resetPasswordToken" value={formik.values.resetPasswordToken} />

      <Button type="submit" primary fluid loading={formik.isSubmitting}>
        {t("update")}
      </Button>

      {error && <Message negative>{error}</Message>}
    </Form>
  );
}
